<template>
    <form @submit.prevent="generate">
    <div>
        <div class="mb-3">
            <div class="ib">
                <label for="deviceID">DeviceID</label>
                <input type="text" class="form-control" v-model="deviceId" name="deviceID"  id="deviceID" placeholder="xx" style="width:4rem;"
                       pattern='^([0-7][0-9a-fA-F])$' minlength="2" maxlength="2" required="">
            </div>
            <div class="ib">
                <label for="model">Model</label>
                <input type="text" class="form-control" v-model="model" name="model"  id="model" placeholder="xx xx xx xx" style="width:7rem;"
                       pattern='^([0-7a-eA-E][0-9a-fA-F]) ([0-7a-eA-E][0-9a-fA-F]) ?([0-7a-eA-E][0-9a-fA-F])? ?([0-7a-eA-E][0-9a-fA-F])?\s*$' minlength="4" maxlength="11" required="">
            </div>
            <div class="ib">
                <label for="sa">Start Address</label>
                <input type="text" class="form-control" v-model="startAddress" name="sa" id="sa" placeholder="xx xx xx xx" style="width:8rem;"
                       pattern='^([0-7][0-9a-fA-F]) ([0-7][0-9a-fA-F]) ?([0-7][0-9a-fA-F])? ?([0-7][0-9a-fA-F])?\s*$' minlength="4" maxlength="11" required="">
            </div>
            <div class="ib">
                <label for="requests"># Requests</label>
                <input type="number" class="form-control" v-model="requests" name="step" id="requests" style="width:6rem;" min="1" required="">
            </div>
            <div class="ib form-check">
                <input class="form-check-input" type="radio" name="incAddress" id="incAddress" value="0" v-model="incDec">
                <label class="form-check-label" for="incAddress">
                    Inc Address
                </label>
            </div>
            <div class="ib form-check">
                <input class="form-check-input" type="radio" name="decAddress" id="decAddress" value="1" v-model="incDec">
                <label class="form-check-label" for="decAddress">
                    Dec Address
                </label>
            </div>
            <div class="ib">
                <label for="deltaAddress">Change Address By</label>
                <input type="text" class="form-control" v-model="deltaAddress" name="deltaAddress" id="deltaAddress" placeholder="xx xx xx xx" style="width:8rem;"
                       pattern='^([0-7][0-9a-fA-F]) ([0-7][0-9a-fA-F]) ?([0-7][0-9a-fA-F])? ?([0-7][0-9a-fA-F])?\s*$' minlength="4" maxlength="11">
            </div>
        </div>
        <div class="mb-3">
            <div class="form-check ib">
                <input class="form-check-input" type="radio" name="dataSet" id="dataSet" value="0" v-model="sendReceive">
                <label class="form-check-label" for="dataSet">
                    Data Set 1 (DT1)
                </label>
            </div>
            <div class="form-check ib">
                <input class="form-check-input" type="radio" name="dataRequest" id="dataRequest" value="1" v-model="sendReceive">
                <label class="form-check-label" for="dataRequest">
                    Data Request 1 (RQ1)
                </label>
            </div>
            <div class="ib">
                <label for="deviceID" class="ib me-1">Bytes To Request:</label>
                <input type="text" :disabled="sendReceive==='0'" class="form-control ib" v-model="bytesToRequest" name="reqLen"  id="reqLen" placeholder="xx xx xx xx" style="width:8rem;"
                       pattern='^([0-7][0-9a-fA-F]) ([0-7][0-9a-fA-F]) ?([0-7][0-9a-fA-F])? ?([0-7][0-9a-fA-F])?\s*$' minlength="4" maxlength="11">
            </div>
            <input type="submit" class="btn btn-primary" value="Generate">
        </div>
        <div class="mb-5">
            <label for="payload">Data to Set</label>
            <textarea :disabled="sendReceive==='1'" class="form-control" :class="payloadValid ? '' : 'is-invalid'" id="payload" rows="2" v-model="payload" placeholder="xx ..."></textarea>
            <div id="payloadFeedback" class="invalid-feedback">
                Please enter a valid string of hex values at least one byte long
            </div>
        </div>
        <div class="mb-1">
            <label for="result">Result</label>
            <textarea class="form-control" id="result" rows="15" v-model="result" ></textarea>
        </div>
    </div>
    </form>
</template>

<script>

function countHexDigits(str) {
    return str.split(" ").length;
}

function hexStringToNumbers(str) {
    let bytes = str.split(" ");
    let rv=[];
    for( let byte of bytes)
        rv.push( parseInt(byte,16));
    return rv;

}
/* eslint-disable */
// return array of hex values in sysex format, i.e. 7 bits
function getSysexValueArray(value, length=2) {
    let rv=[];
    // generate little endian
    for(let i=0;i<length;i++) {
        rv.push( value & 0x7f );
        value>>=7;
    }
    return rv.reverse();       // to big endian
}

// array of sysex bytes  decimal val
function convertSysexValueListToDecimal(list) {
    list = list.reverse(); // low little endian
    let total=0;
    let i=0;
    for ( let byte of list )
        total += byte * Math.pow(128,i++);
    return total;
}

let hexVal="0123456789ABCDEF";
function decimalListToHex(list) {
    let rv=[];
    for ( let byte of list )
        rv.push( hexVal[((byte>>4) & 0xf)] + hexVal[byte & 0xf] );
    return rv;
}


export default {
    name: "GenComponent",
    data() {
        return {
            deviceId:"11",
            model:"00 00 00 0C",
            startAddress:"01 00 00 00",
            deltaAddress:"00 00 10 00",
            requests:1,
            incDec:"0",
            sendReceive:"0",
            bytesToRequest:"00 00 01 00",
            payload:"",
            payloadValid:true,
            result:""
        }
    } ,
    methods: {
        generate() {
            this.payloadValid=true;
            let setBytes=[];
            if ( this.sendReceive==="0" ) {
                if ( !this.payload.match("^([0-7][0-9a-fA-F]) ?(( ?([0-7][0-9a-fA-F]))*\\s*)$") ) {
                    this.payloadValid = false;
                    return;
                }
                setBytes=hexStringToNumbers(this.payload)
            }
            let header=[0xf0,0x41];
            header.push(...hexStringToNumbers(this.deviceId));
            header.push(...hexStringToNumbers(this.model));
            header.push(this.sendReceive==="0" ? 0x12 : 0x11)
            let bytesToRequest=hexStringToNumbers(this.bytesToRequest);
            let deltaAddress = convertSysexValueListToDecimal(hexStringToNumbers(this.deltaAddress)) * (this.incDec==="0" ? 1: -1);
            let addressHexCount = countHexDigits(this.startAddress);
            if ( this.sendReceive==="1" && countHexDigits(this.bytesToRequest)!=addressHexCount) {
                window.alert("Bytes to request must be same length as start address");
                return;
            }

            let sa = convertSysexValueListToDecimal(hexStringToNumbers(this.startAddress));

            let messages=[];
            for ( let messageCount=0;messageCount<this.requests; messageCount++ ) {
                let messagePayload = [];
                messagePayload.push(... getSysexValueArray(sa,addressHexCount));

                if ( this.sendReceive==="0") {
                    messagePayload.push(... setBytes); }
                else
                    messagePayload.push(... bytesToRequest);

                let cs=0;
                for(let v of messagePayload)
                    cs+=v;
                cs = cs % 128;
                cs = 128-cs;
                cs = cs % 128;
                messagePayload.push(cs, 0xf7);

                let message=[...header,...messagePayload];
                messages.push(decimalListToHex(message).join(" "));
                sa+=deltaAddress;
                if ( sa<0 ) {
                    messages.put("gone under address 0");
                    break;
                }
            }
            this.result=messages.join("\r\n");
        }
    }
}
</script>

<style scoped>

</style>